import departmentsService from '../../services/departmentsService'

class DepartmentsController {
  fetchDepartments = departmentsService.fetchDepartments
}

export default new DepartmentsController()
 


// WEBPACK FOOTER //
// ../src/controllers/departmentsController/departmentsController.js